﻿export class UtilHelper {
  public static responses(data) {
    return JSON.parse(JSON.stringify(data));
  }

  public static validator(valor, tipo) {
    var ret = true;
    var regex;
    switch (tipo) {
      case 'integer': regex = /^[\-\+]?\d+$/; break;
      case 'number': regex = /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/; break; //numeros incluido flotante
      case 'ddmmyyyy': regex = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/; break; //fecha DD/MM/YYYY
      case 'yyyymmdd': regex = /^(\d{4})[\/\-\.](0?[1-9]|1[012])[\/\-\.](0?[1-9]|[12][0-9]|3[01])$/; break; //fecha YYYY-MM-DD
      case 'email': regex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/; break;
      case 'text': regex = /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚüÜ\n \.\:\,\;\-\#\/\(\)\"\%\°]+$/i; break; //texto incluido eñe, acentos, espacio, punto, coma y guión medio
      default: regex = /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚüÜ\ \.\:\,\-\#\/]+$/i; break;
    }
    if (!regex.test(valor)) {
      ret = false;
    }
    return ret;
  }

  public static onlyNumbersInt(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      if (event.keyCode == 8 || event.keyCode == 46) {
        return true;
      }
      else {
        event.preventDefault();
      }
    }
  }

  public static getDashboardUrl(rol) {//fRnk, por definir
    let url = '/';
    switch (rol) {
      case 1: url = '/'; break;
      default: url = '/'; break;
    }
    return url;
  }
}